import type { UrlUnfurledData } from 'core_main/pubnub/types';

/**
 * Carousel mode (KUS-9022 / iOS parity): use carousel when there are multiple previews **and**
 * every preview has a valid non-negative integer `preferredOrder`. Otherwise the widget keeps
 * the stacked layout. Does **not** read org chat settings; wire `preferredOrder` is the only gate.
 */
export function shouldUseCarouselForUrlPreviews(
  previews: UrlUnfurledData[],
): boolean {
  if (!previews || previews.length < 2) {
    return false;
  }
  return previews.every((preview) => {
    const order = preview.preferredOrder;
    return (
      typeof order === 'number' &&
      Number.isFinite(order) &&
      Number.isInteger(order) &&
      order >= 0
    );
  });
}

export function sortPreviewsByPreferredOrder(
  previews: UrlUnfurledData[],
): UrlUnfurledData[] {
  return [...previews].sort((a, b) => {
    const ao = a.preferredOrder ?? 0;
    const bo = b.preferredOrder ?? 0;
    return ao - bo;
  });
}
